var _path, _path2, _path3, _circle, _circle2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6743 27.0157L22.4065 24.5182C22.5701 24.4322 22.751 24.3882 22.9357 24.3882C23.5592 24.3882 24.0634 24.8892 24.0634 25.5088V29.3583C24.0634 29.4998 24.0403 29.6432 23.9884 29.7752C23.7382 30.412 22.9973 30.672 22.4065 30.3622L17.6743 27.8648L12.9421 30.3622C12.3532 30.674 11.6104 30.412 11.3602 29.7752C11.3082 29.6432 11.2852 29.5017 11.2852 29.3583V25.5088C11.2852 24.8892 11.7894 24.3882 12.4129 24.3882C12.5976 24.3882 12.7785 24.4341 12.9421 24.5182L17.6743 27.0157ZM17.6801 32.4811C17.1605 32.4811 16.7409 32.0623 16.7409 31.5479C16.7409 31.0335 17.1624 30.6147 17.6801 30.6147C18.1977 30.6147 18.6192 31.0335 18.6192 31.5479C18.6192 32.0623 18.1977 32.4811 17.6801 32.4811Z",
    fill: "#050F4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4907 16.1089V10.2886C24.4907 11.5013 23.1496 12.4707 17.1893 12.4707C12.4211 12.4707 11.0304 15.9068 10.9311 17.6248C10.9311 21.4147 12.8681 23.5369 17.1893 23.5369C21.5105 23.5369 24.4907 19.7471 24.4907 16.1089Z",
    fill: "#FF5A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87233 13.3045C4.26105 8.45746 11.5663 -0.159373 18.5539 6.19555C23.9534 6.19555 24.4907 9.22342 24.4907 10.2886M24.4907 10.2886V16.1089C24.4907 19.7471 21.5105 23.5369 17.1893 23.5369C12.8681 23.5369 10.9311 21.4147 10.9311 17.6248C11.0304 15.9068 12.4211 12.4707 17.1893 12.4707C23.1496 12.4707 24.4907 11.5013 24.4907 10.2886Z",
    stroke: "#FF5A5F",
    strokeWidth: 0.851884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.577,
    cy: 16.3017,
    r: 2.56139,
    stroke: "#050F4E",
    strokeWidth: 0.851884
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9794,
    cy: 16.3017,
    r: 2.56139,
    stroke: "#050F4E",
    strokeWidth: 0.851884
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.478 15.7492C18.2539 15.6852 18.0233 15.6404 17.78 15.6404C17.5367 15.6404 17.3061 15.6852 17.082 15.7492",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.478 15.7492C18.2539 15.6852 18.0233 15.6404 17.78 15.6404C17.5367 15.6404 17.3061 15.6852 17.082 15.7492",
    stroke: "#050F4E",
    strokeWidth: 0.851884
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f77b90f4a222b9f9e71670e437d0d18.svg";
export { ForwardRef as ReactComponent };